import PropTypes from 'prop-types';

export default PropTypes.shape({
  opening_hours: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  next_intervals: PropTypes.arrayOf(PropTypes.shape({
    open: PropTypes.string.isRequired,
    close: PropTypes.string.isRequired,
  })).isRequired,
});
